<template>
	<h3>
		Substudies
		<button type="button" class="btn btn-primary btn-xs glypicon glyphicon-plus" v-on:click="showNewModal = true"></button>
	</h3>
	<div class="progress" v-show="loadingSubstudies">
	  <div class="progress-bar progress-bar-striped active" role="progressbar"
	  aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width:100%">
	    Loading&hellip;
	  </div>
	</div>
	<table class="table table-striped" v-show="!loadingSubstudies">
		<thead>
			<tr>
				<th scope="col">Substudy</th>
				<th scope="col">Create tasks on participant creation?</th>
				<th scope="col">Active</th>
				<th scope="col">&nbsp;</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="substudy in orderedSubstudies"  :key="substudy.id" class="substudy" :class="{ 'inactive': !substudy.active }">
				<td>
					<a :href="'/substudies/'+substudy.id">{{ substudy.name }}</a>
				</td>
				<td>
					<div class="btn-group">
					  	<button class="btn btn-xs btn-toggle" :class="substudy.auto_tasks ? 'btn-success' : 'btn-default'" v-on:click="toggleAutoTasks(substudy)">
					  		{{substudy.auto_tasks ? 'ON': '&nbsp;&nbsp;&nbsp;&nbsp;'}}
					  	</button>
					  	<button class="btn btn-xs btn-toggle" :class="!substudy.auto_tasks ? 'btn-danger' : 'btn-default'" v-on:click="toggleAutoTasks(substudy)">
					  		{{!substudy.auto_tasks ? 'OFF': '&nbsp;&nbsp;&nbsp;&nbsp;'}}
					  	</button>
					</div>
				</td>
				<td>
					{{ (substudy.active) ? 'Active' : 'Inactive' }}	
				</td>
				<td class="text-right">
					<button class="btn btn-xs btn-default" v-on:click="toggleActive(substudy)">{{ (substudy.active) ? 'deactivate' : 'activate'}}</button>
					<button class="btn btn-xs btn-default" v-on:click="deleteSubstudy(substudy)">
						<span class="glyphicon glyphicon-trash"></span> delete
					</button>
				</td>
			</tr>
		</tbody>
	</table>
	
	<create-substudy
    v-model:showModal="showNewModal"
    v-on:confirm="confirmSave"
    v-on:closed="showNewModal=false"
  	></create-substudy>
</template>

<script setup>
  import { ref, computed, onMounted } from 'vue'
  import CreateSubstudy from './modals/CreateSubstudy.vue'

  const substudies = ref([])
  const substudyStatuses = ref([])
  const showNewModal = ref(false)
  const loadingSubstudies = ref(true)
  const sort = ref({ field: 'active', dir: 'desc' })

  onMounted(() => {
		fetchSubstudies();
		fetchSubstudyStatuses();
	})

	const orderedSubstudies = computed(() => {
		var ordered = substudies.value.sort(function (item1, item2) {
			var ret = 0
			if (item1[sort.value.field] < item2[sort.value.field]) {
				ret = -1;
			} 
			if (item1[sort.value.field] > item2[sort.value.field]) {
				ret = 1
			}

			return (sort.value.dir == 'desc') ? ret*-1 : ret;
		}.bind(this));

		return ordered;
	})

	function confirmSave() {
		showNewModal.value = false;
		fetchSubstudies();
	}

	function fetchSubstudies() {
		axios.get('/api/substudies')
			.then(function (response) {
				substudies.value = response.data;
				loadingSubstudies.value = false;
			}.bind(this))
			.catch(function () {
				alert('Failed to retrieve substudies.');
			});
	}

	function fetchSubstudyStatuses() {
		axios.get('/api/substudy-statuses')
			.then(function (response) {
				substudyStatuses.value = response.data;
			}.bind(this))
			.catch(function (error) {
				console.error(error);
				alert('Failed to retrieve substudy statuses.');
			});
	}

	function toggleActive(substudy) {
		if (substudy.active == 1 && !confirm('Deactivating this substudy will auto-cancel all related pending tasks. Are you sure you want to continue?')) {
			return;
		}
		substudy.active = substudy.active == 1 ? 0 : 1;
		if (!substudy.active) {
			substudy.auto_tasks = 0;
		}
		axios.put('/api/substudies/'+substudy.id, substudy)
			.then(function (response) {
				substudy = response.data
			}.bind(this))
			.catch(function (error) {
				console.error(error);
				alert('There was a problem updating the substudy');
			})
	}

	function toggleAutoTasks(substudy) {
		substudy.auto_tasks = substudy.auto_tasks == 1 ? 0 : 1;
		axios.put('/api/substudies/'+substudy.id, substudy)
			.then(function (response) {
				substudy = response.data
			}.bind(this))
			.catch(function (error) {
				console.error(error);
				alert('There was a problem updating the substudy');
			})
	}

	function deleteSubstudy(substudy) {
		if (confirm('You are about to delete substudy '+substudy.name+'. This can\'t be undone.  Are you sure you want to continue?')) {
			axios.delete('/api/substudies/'+substudy.id)
				.then(function (response) {
					substudies.value.splice(substudies.value.indexOf(substudy), 1);
				}.bind(this))
				.catch(function (error) {
					console.error(error);
					alert('Failed to delete the substudy');
				});
		}
	}
</script>

<style scoped>
	.btn-toggle:focus {
		outline: none;
	}
	.btn-toggle.btn-default:focus {
		background-color: #fff;
		border-color: #ccc;
	}
</style>